import { ShoppingCart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '@/contexts/CartContext';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const FloatingCartButton = () => {
  const { itemCount } = useCart();
  const location = useLocation();

  // Hide on cart page or when cart is empty
  if (itemCount === 0 || location.pathname === '/cart') return null;

  return (
    <Link to="/cart" className="fixed top-20 lg:top-24 right-4 md:right-6 z-40 animate-scale-in">
      <Button
        size="lg"
        className="rounded-full h-12 w-12 md:h-14 md:w-14 shadow-lg shadow-primary/30 hover:scale-110 transition-transform relative"
      >
        <ShoppingCart className="w-6 h-6" />
        <Badge 
          className="absolute -top-2 -right-2 h-6 w-6 rounded-full p-0 flex items-center justify-center bg-destructive text-destructive-foreground text-xs font-bold animate-pulse"
        >
          {itemCount}
        </Badge>
      </Button>
    </Link>
  );
};

export default FloatingCartButton;
